import { useState, useEffect } from 'react';

import { setExpirationData } from '../helpers/setExpirationData';

export const useLocaleStorage = (key: string, defaulValue: any) => { 
    const expirationData = new Date(new Date().getTime() + 1 * 3600 * 1000);
    // const expirationData = new Date(new Date().getTime() - (1000*60*60));
    const expirationDate = new Date(localStorage.getItem('expirationData'));     
    
    const [value, setValue] = useState(() => {
        try {
            const storedValue = localStorage.getItem(key); 
            if (!storedValue) {                
                setExpirationData(String(expirationData)); 
                return defaulValue;
            }
            if (storedValue) {               
                if ((expirationDate <= new Date())) {                   
                    setExpirationData(String(expirationData)); 
                    return defaulValue;
                }
                if (!(expirationDate <= new Date())) {                     
                    return JSON.parse(storedValue);
                }               
            }        
        } catch {            
            setExpirationData(String(expirationData));
            return defaulValue;
        }
    });
    useEffect(() => {
        const rawValue = JSON.stringify(value);
        localStorage.setItem(key, rawValue);
    }, [key, value]);
    return [value, setValue];
}


